/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Page_Install_TitleInputs */

const en_pc_page_install_title = /** @type {(inputs: Pc_Page_Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to Install PhotoCraft ArtCraft on Mac, Windows and Linux`)
};

const zh_pc_page_install_title = /** @type {(inputs: Pc_Page_Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PhotoCraft ArtCraft 安装教程：Mac、Windows、Linux`)
};

/**
* | output |
* | --- |
* | "How to Install PhotoCraft ArtCraft on Mac, Windows and Linux" |
*
* @param {Pc_Page_Install_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_page_install_title = /** @type {((inputs?: Pc_Page_Install_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Page_Install_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_page_install_title(inputs)
	return zh_pc_page_install_title(inputs)
});
export { pc_page_install_title as "pc.page.install.title" }